import React, { memo, useMemo } from 'react'
import dynamic from 'next/dynamic'
import { useIntl } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Page from 'components/layout/Page'
import usePageProps from 'hooks/usePageProps'
import Skeleton from '@mui/material/Skeleton'
import Quoter from 'components/shared/Quoter'
import FaqsVTA from 'components/VTA/FaqsVTA'
import MainBanner from 'components/shared/MainBanner'
import { useMediaQuery } from '@mui/material'
import SellItWithClikAuto from './SellItWithClikAuto'
import VtaBranchesGallery from './VtaBranchesGallery'
import sx from './styles'

const ReviewsAndPressSkeleton = dynamic(() => import('components/shared/GoogleReviewsAndPress/ReviewsAndPressSkeleton'))

const GoogleReviewsAndPress = dynamic(
  () => import('components/shared/GoogleReviewsAndPress'),
  {
    loading: () => (
      <ReviewsAndPressSkeleton
        showPress
        sx={sx.googleReviewsContainer}
      />
    ),
    ssr: false,
  },
)

const RatingComponent = dynamic(
  () => import('components/VTA/RatingVTA'),
  {
    loading: () => (
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={160}
        width="100%"
      />
    ),
    ssr: false,
  },
)

const SellYourCarVariant = () => {
  const {
    commonFaqsEasy,
    mainBanner,
    mainBannerEasy,
    banners,
  } = usePageProps()
  const { formatMessage: f } = useIntl()
  const isEasyVariant = true // set 1 to get VTA copys
  const mainBannerData = isEasyVariant ? mainBannerEasy : mainBanner
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  // if isEsyVariant = false then timeline, internalsections, rating, makes
  // varaint = 0 then timeline, rating, makes
  // varaint = 1 then rating, makes, internal, timeline
  const imagesBranches = banners
  const sectionsVariables = useMemo(() => [
    {
      id: 'rating-section',
      class: sx.ratingComponent,
      component: (
        <RatingComponent
          text={f({ id: 'SYC_RATING_TEXT_EASY_MOBILE' })}
          textVariant="strong"
          variant
        />
      ),
      visible: true,
      position: 1,
    },
    {
      id: 'sell-it-with-clikauto',
      component: (
        <SellItWithClikAuto
          title="SYC_MAKES_TITLE_SELLIT"
          textLeft
          showItems
        >
          <Quoter
            variantTitle="h3"
            rowTitle="SYC_WHAT_CAR_DO_YOU_SELL_QUOTER_1"
            buttonId="vta_cotizador_home"
            sx={sx.quoterContainer}
            buttonLabel="QUOTE"
          />
        </SellItWithClikAuto>
      ),
      visible: true,
      position: 2,
    },
    {
      id: 'gallery',
      component: (
        <VtaBranchesGallery
          title="SYC_BRANCHES_TITLE"
          images={imagesBranches}
        />
      ),
      visible: true,
      position: 3,
    },
    {
      id: 'sell-it-clikauto-2',
      component: (
        <SellItWithClikAuto
          title="SYC_MAKES_TITLE_SELLIT_VARIANT"
        >
          <Quoter
            variantTitle="h4"
            title="SYC_WHAT_CAR_DO_YOU_SELL_QUOTER_2"
            buttonId="vta_cotizador_home"
            sx={sx.quoterContainer}
            buttonLabel="QUOTE"
          />
        </SellItWithClikAuto>
      ),
      visible: true,
      position: 4,
    },
  ], [isEasyVariant, isMobile])

  return (
    <>
      <Page>
        <Box
          sx={isMobile ? sx.containerMobile : ''}
        >
          <Box sx={{ backgroundColor: 'background.grey' }}>
            <MainBanner
              contactText={isEasyVariant ? '' : 'SYC_IF_THE_CAR_YOU_ARE_SELLING_IS_FROM_2000_TO_2011'}
              {...mainBannerData}
              sx={sx.mainContainerABTest}
              maxWidth="lg"
              variant
            >
              <Quoter
                variant={isMobile ? 'row' : 'column'}
                buttonLabel="QUOTE"
                buttonId="vta_cotizador_home"
                sx={sx.quoterFirstContainer}
                isVTA
                disclaimer={isEasyVariant ? '' : 'SYC_QUOTER_DISCLAIMER'}
                isMain
              />
            </MainBanner>
          </Box>

          <Box sx={isEasyVariant ? '' : sx.linearGradient}>
            <Grid
              size={12}
              container
            >
              {sectionsVariables
                .filter((i) => i.visible)
                .sort((a, b) => a.position - b.position)
                .map((section) => (
                  <Grid
                    size={12}
                    sx={section.class ? section.class : null}
                    key={section.id}
                  >
                    {section.component}
                  </Grid>
                ))}
            </Grid>
          </Box>

          <FaqsVTA
            data={commonFaqsEasy}
            showTitle
            variant
          />

          <GoogleReviewsAndPress
            variant="row"
            title={isEasyVariant ? 'SYC_REVIEWS_TITLE_VARIANT_1_EASY' : 'SYC_REVIEWS_TITLE_VARIANT_1'}
            buttonLabel="SYC_SEE_ALL_REVIEWS_1"
            sx={sx.googleReviewsContainer}
            showPress={false}
          />
        </Box>
      </Page>
    </>
  )
}
export default memo(SellYourCarVariant)
